export default "__VITE_ASSET__aW_xkp9Q__"